import value from "./value";
export default function variant(name, prop, values) {
  return props => {
    const variant = props[prop] && values[props[prop]];
    return variant && value(name, props, variant) || props[prop];
  };
}
//# sourceMappingURL=variant.js.map